import { render, staticRenderFns } from "./Capacity.vue?vue&type=template&id=1355b21d&scoped=true"
import script from "./Capacity.vue?vue&type=script&lang=js"
export * from "./Capacity.vue?vue&type=script&lang=js"
import style0 from "./Capacity.vue?vue&type=style&index=0&id=1355b21d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355b21d",
  null
  
)

export default component.exports